import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { FormTransformers } from '@/common/utils/formTransformers'
import useEnableTmaisClient from '@/features/tmaisUsers/hooks/useEnableTmaisUser'
import { useQueryClient } from '@tanstack/react-query'
import { Dispatch, SetStateAction, useState } from 'react'
import { useForm } from 'react-hook-form'

interface EnableTmaisUserModalProps {
  tmaisUserId?: string
  setMessages: Dispatch<SetStateAction<boolean | string[]>>
}

export const EnableTmaisUserModal = ({ tmaisUserId, setMessages }: EnableTmaisUserModalProps) => {
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)

  const { mutate: enableTmaisUser } = useEnableTmaisClient({
    id: tmaisUserId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tmaisUser', tmaisUserId] })
      reset()
      setIsOpen(false)
    },
    onError: (error) => FormTransformers.errorsTransformer({ setError, setMessages })(error),
  })

  const {
    reset,
    setError,
    handleSubmit,
  } = useForm()

  const onSubmit = () => {
    enableTmaisUser()
  }

  return (
    <Modal
      Trigger={
        <Button
          operationKlassToCheckPermission="Admin::Tmais::Users::Enable"
          type="button"
          variant="outline-error"
        >
          Desbloquear
        </Button>
      }
      title="Desbloquear cliente"
      subtitle="Tem certeza que deseja desbloquear esse cliente?"
      subtitleClassName="mt-1 text-white-300"
      useCancellableFooter
      confirmButtonText='Confirmar desbloqueio'
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirm={handleSubmit(onSubmit)}
    />
  )
}
